module.exports = __webpack_public_path__ + "static/media/ppcc.cd24b0ea.svg";